import { Tooltip } from "antd";
import { QuestionCircleOutlined } from '@ant-design/icons';

export default function InfoTooltip ({text}) {
  return (
    <Tooltip title={text}>
      <QuestionCircleOutlined style={{color: "#1677ff"}}/>
    </Tooltip>
  );
}